'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function ChangePasswordController($filter, $state, PageHeading, $stateParams, userId, Toast, UserComponent) {
	'ngInject';

	var vm = this;
	vm.changePassword = changePassword;
	vm.comeFrom = $stateParams.comeFrom;
	vm.uiSref = 'app.private.administrators.' + vm.comeFrom;
	vm.userId = userId;
	vm.password = {};

	activate();

	function activate() {
		var heading = $filter('translate')('HEADING.CHANGE_PASSWORD');
		var title = 'BTMS | ' + $filter('translate')('HEADING.CHANGE_PASSWORD');

		PageHeading.setPageHeading(heading, title);
	}

	function changePassword(params, form) {
		var hasEmptyFields = form.password.$error.required;
		var passwordLength = form.password.$error.minlength || form.password.$error.maxlength;
		var passwordConfirmLength = form.passwordConfirm.$error.minlength || form.passwordConfirm.$error.maxlength;
		vm.passwordsMatch = params.password !== params.confirm;

		if (hasEmptyFields || passwordLength || passwordConfirmLength || vm.passwordsMatch) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		var requestParams = {
			'password': params.password
		};

		UserComponent.changePassword(vm.userId, requestParams).then(function (res) {
			if (res.data.errors) {
				Toast.responseError(res.data.errors);
			} else {
				Toast.success($filter('translate')('SUCCESS.UPDATE_PASSWORD'));
				$state.go('app.private.administrators.' + vm.comeFrom, { 'id': userId });
			}
		});
	}
}

exports['default'] = ChangePasswordController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/administrators/change-password/change-password.controller.js
 **/